import { SearchspringFetcher } from '../classes/searchspring-fetcher'
import { normaliseResults } from '../helpers/normalisers'

import { generateSearchspringProvider } from './provider'

export class SearchspringSearch extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { query, originalQuery, page, resultsPerPage, tag, filters, sort } = options
    if (!query) return

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('q', query)

    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)
    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (tag) this.params.set('tag', tag)

    if (sort) this.params.setSort(sort)
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export const SearchspringSearchProvider = generateSearchspringProvider(SearchspringSearch, (results) => {
  return {
    ...results,
    results: normaliseResults(results.results)
  }
})
